import { render, staticRenderFns } from "./Certs.vue?vue&type=template&id=c8be22c6&scoped=true"
import script from "./Certs.vue?vue&type=script&lang=js"
export * from "./Certs.vue?vue&type=script&lang=js"
import style0 from "./Certs.vue?vue&type=style&index=0&id=c8be22c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8be22c6",
  null
  
)

export default component.exports